import Module from '../module.js';
import {Reveal, Typography, Media, Cursor } from '../../animations/index.js';
import CoverSlider from './cover-slider.js';

//css
import './cover.scss';

export class CoverModule extends Module {

	constructor(el) {
		super(el);
	}

	init() {
    this.ready();
    this.reveal = new Reveal(this.node);
    Typography.split(this.node);
    this.media = new Media(this.node);
		this.typography = new Typography(this.node);
    this.cursor = Cursor.init(this.node);
    this.sliders = new CoverSlider(this.node);
	}

  destroy() {
    Cursor.destroyAll();
    this.destroyed();
  }
}

export function createInstance() {
	const instance = new CoverModule();
	return instance;
}
